import React, { useEffect, useState, useCallback } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { Card, CardBody } from "reactstrap";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Link, useNavigate } from "react-router-dom";
import DefaultImage from "../../assets/images/default-img.png";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
import {
  getAllApprovalList,
  updateApprovalStatus,
} from "../../api/casp/approval";
import { Action, DefaultPerPageValue, PerPage } from "../../constants/Common";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import { Modules, TabModule } from "../../constants/Module";
import { ApprovalStatuses, ProjectStatuses } from "../../constants/Status";
import NodataFound from "../../Components/Common/NoDataFound";
import Ticket from "../../assets/images/icons/ticket.png";
import CommentModal from "../../Components/casp/common/CommentModal";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { filter } from "lodash/collection";
import { get } from "lodash/object";
import { getIconPath } from "../../helpers/file_helper";
import ApprovalIcon from "@mui/icons-material/Approval";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { withTranslation, useTranslation } from "react-i18next";
import { getAllProject } from "../../api/casp/project";
import { Role } from "../../constants/Role";
import userImage from "../../assets/images/icons/ticket.png";
import Search from "../../Components/casp/common/Search";

function ProjectApproalSubmission(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [columns, setColumn] = useState([]);
  const [triggerState, setTriggerState] = useState(+new Date());
  const [open, setOpen] = useState(false);
  const [getApprovalId, setGetApprovalId] = useState(0);
  const [getParamsApiObj, setGetParamsApiObj] = useState();
  const [getStatus, setGetStatus] = useState();
  const [mounted, setMounted] = useState(false);
  const { project } = useParams();
  const [page2, setPage2] = useState(0);
  const [rowsPerPage2, setRowsPerPage2] = useState(DefaultPerPageValue);
  const [projectList, setProjectList] = useState([]);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [rowCount, setRowCount] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isLoadingForComplete, setIsLoadingForComplete] = useState(false);
  const [search, setSearch] = useState("");
  const { t } = useTranslation();

  const navigate = useNavigate();

  const columnsForComplete = [
    {
      field: "projectName",
      headerName: props.t("Startup Name"),
      flex: 1.5,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
          <span
            style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => navigate(`/project/${params.row.id}/details`)}
          >
            {params.row.projectName}
          </span>
      )
    },
    {
      field: "founderName",
      headerName: props.t("Founder Name"),
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <span>
          {params?.row?.founderName}
        </span>
      ),
    },
  ];

  const [columnData, setColumnData] = useState([...columnsForComplete])

  const handleClickOpen = (approvalId, paramsApiObj, status) => {
    setOpen(true);
    setGetApprovalId(approvalId);
    setGetParamsApiObj(paramsApiObj);
    setGetStatus(status);
  };

  const handleClose = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setOpen(false);
    setGetApprovalId(0);
    setGetParamsApiObj();
    setGetStatus();
  };

  const handleTriggerAdd = (status, comments) => {
    const updatedParamsApiObj = {
      ...getParamsApiObj,
      comments: comments,
    };
    handleApproval(getApprovalId, updatedParamsApiObj, status);
    handleClose();
  };

  const handleApproval = async (approvalId, paramsApiObj, status) => {
    try {
      setIsLoading(true);
      const updatedParamsApiObj = { ...paramsApiObj }; // Create a copy of paramsApiObj
      updatedParamsApiObj.status = status;
      const res = await updateApprovalStatus(
        parseInt(approvalId),
        updatedParamsApiObj
      );
      if (page === 0) {
        setTriggerState(+new Date());
      } else {
        setPage(0);
        setTriggerState(+new Date());
      }
      if (status === ApprovalStatuses.APPROVED) {
        toast.success(res.data.message);
      }
      if (status === ApprovalStatuses.REJECTED) {
        toast.info(res.data.message);
      }
    } catch (errors) {
      setIsLoading(false);
      toast.error("Something went wrong.");
      setTriggerState(+new Date());
    }
  };

  const getProjectApprovalList = async ({ page = 1, perPage = 5 }) => {
    try {
      setIsLoading(true);
      const projectApprovalParams = {
        ...(isNaN(parseInt(project))
          ? undefined
          : {
            projectId: parseInt(project),
          }),
        userId: loggedInUser.id,
        perPage: perPage,
        page,
        filterFields: [
          "module",
          "status",
          // "currentApprovalUser",
          "moduleProposedStatus",
        ],
        filterInputs: [
          Modules.PROJECT,
          ApprovalStatuses.PENDING,
          // ApprovalStatuses.PENDING,
          props.module === TabModule.PROJECT_APPROVAL
            ? ProjectStatuses.ONGOING
            : ProjectStatuses.COMPLETED,
        ],
      };
      const res = (await getAllApprovalList(projectApprovalParams)).data.data;
      if (res.data.length > 0) {
        let approvalModuleDetails = res.data.map((approvalItem) => ({
          projectName: approvalItem.moduleDetails?.name,
          projectManager: approvalItem.moduleDetails?.projectAdmin?.name,
          actions: Action.VIEW,
          id: approvalItem.id,
          actionObj: {
            moduleId: approvalItem.moduleId,
            module: approvalItem.module,
            projectId: approvalItem.moduleId,
          },
        }));
        setRows(approvalModuleDetails);
        setTotalRows(res.meta.total);
      } else {
        setRows([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const paginationModelMethod = async (data) => {
    if (rowsPerPage !== data.pageSize) {
      setRowsPerPage(data.pageSize);
    } else {
      setRowsPerPage(data.pageSize);
      setPage(data.page);
    }
  };

  const fetchProjectList = async (queryParams) => {
    try {
      setIsLoadingForComplete(true);
      let params = {
        isComplete: true,
        ...queryParams,
        ...(search && { search }),
      }
      const res = (await getAllProject(params)).data.data;
      let level = (params?.page + 1 - 1) * params?.perPage;
      const resultData = res.data.map((res) => {
        return {
          id: res.id,
          indexNo: ++level,
          uniqueProjectId: res.uniqueProjectId,
          projectName: res.name,
          founderName: res.projectAdmin.name,
        };
      });
      setProjectList(resultData);
      setRowCount(res.meta.total);
      setIsLoadingForComplete(false);
    } catch (error) {
      setIsLoadingForComplete(false);
    }
  }

  useEffect(() => {
    if (props.module === TabModule.PROJECT_SUBMISSION_APPROVAL) {
      fetchProjectList({ 
        page: page2 + 1, 
        perPage: rowsPerPage2, 
        filterFields: ['status'], 
        filterInputs: [ProjectStatuses.COMPLETED],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerData,props.module]);

  const paginationModelMethodForComplete = async (data) => {
    setPage2(data.page);
    setRowsPerPage2(data.pageSize);
    setTriggerData(+new Date());
  };

  // when chaging the tab this useEffect is used
  useEffect(() => {
    if (mounted) {
      setSearch('')
      setPage2(0)
      setRows([]);
      setTotalRows(0);
      page > 0
        ? setPage(0)
        : getProjectApprovalList({ page: page + 1, perPage: rowsPerPage });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.module]);

  // when changing the page or approved from last page this useEffect is used
  useEffect(() => {
    if (mounted) {
      getProjectApprovalList({ page: page + 1, perPage: rowsPerPage });
    }
    const data = () => {
      setColumn([
        {
          field: "projectName",
          headerName: props.t("Startup Name"),
          width: 400,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="ProjSubmissionIcon text-truncate"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                className="MuiDataGrid-cellContent mx-0"
                title={params.value}
              >
                {params.row.projectName}
              </div>
            </div>
          ),
        },
        {
          field: "projectManager",
          headerName: props.t("Founder"),
          width: 400,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="MilestoneSubmissionIcon"
              style={{ display: "flex", alignItems: "center" }}
            >
              {params.row.projectManager && (
                <img
                  src={DefaultImage}
                  alt={params.row.pmName}
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                />
              )}
              <div className="MuiDataGrid-cellContent mx-2">
                {params.row.projectManager}
              </div>
            </div>
          ),
        },
        {
          field: "actions",
          headerName: props.t("Actions"),
          width: 565,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="proSubmissionActions"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Button
                disableElevation
                variant="contained"
                className="approveBtn"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#90EE90",
                  color: "black",
                  textTransform: "none",
                }}
                onClick={() =>
                  handleApproval(
                    params.row.id,
                    params.row.actionObj,
                    ApprovalStatuses.APPROVED
                  )
                }
              >
                <DoneIcon />
                {props.t("Approve")}
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="error"
                className="rejectBtn"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#FFC0CB",
                  color: "black",
                  textTransform: "none",
                }}
                onClick={() =>
                  handleClickOpen(
                    params.row.id,
                    params.row.actionObj,
                    ApprovalStatuses.REJECTED
                  )
                }
              >
                <ClearIcon />
                {props.t("Reject")}
              </Button>
              <Link
                to={
                  props.module === TabModule.PROJECT_APPROVAL
                    ? `/project/${params.row.actionObj.moduleId}/view-project-approval`
                    : "/#"
                }
                className="viewSkyBtn statusButton statusViewBtn mx-4"
              >
                <RemoveRedEyeOutlinedIcon />
              </Link>
            </div>
          ),
        },
      ]);
    };
    data();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, triggerState, localStorage.getItem("I18N_LANGUAGE")]);

  // when changing the row perPage
  useEffect(() => {
    setRows([]);
    if (page === 0) {
      setTriggerState(+new Date());
    } else {
      setPage(0);
    }
    setMounted(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  const getRowId = (row) => row.id;
  const getRowIdForComplete = (row) => row.id;

  const globalSearch = async (params) => {
    setSearch(params.search);
    // await fetchProjectList({ ...params });
    await fetchProjectList({ 
    ...params, 
    page: 1
  });
  };

  return (
    <div className="page-content position-relative">
      <Helmet
        onChangeClientState={(newState, addedTags) => {
          try {
            // Check if we added any new link[rel="icon"] elements.
            const newFaviconElems = filter(get(newState, "linkTags", []), {
              rel: "icon",
            });

            if (!newFaviconElems.length) {
              return;
            }

            // Get the href of the last link element we just added, which
            // we assume is the most recently-added favicon.
            const newFaviconHref =
              newFaviconElems[newFaviconElems.length - 1].href;

            // Remove all react-helmet link elements with rel="icon" that
            // do not have the href of our recently-added favicon.
            // If no other favicon elements exist, we don't have to do
            // anything.
            const existingFavicons = document.querySelectorAll(
              `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
            );

            if (existingFavicons.length) {
              existingFavicons.forEach((e) => e.parentNode.removeChild(e));
            }

            // Remove and re-add the latest link element to make sure
            // the browser uses it.
            const newFaviconElem = document.querySelector(
              `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
            );
            const iconToShow =
              props.module === TabModule.PROJECT_APPROVAL ? (
                <ApprovalIcon />
              ) : (
                <DoneAllIcon />
              );

            if (newFaviconElem) {
              const newFavElement = newFaviconElem.cloneNode(true);
              newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                  iconToShow
                )}</svg>`
              )}`;
              const parentElem = newFaviconElem.parentNode;
              parentElem.removeChild(newFaviconElem);
              parentElem.appendChild(newFavElement);
            }
          } catch (e) {
            console.error(e);
          }
        }}
      >
        <title>
          {props.module === TabModule.PROJECT_APPROVAL
            ? props.t("Startups Waiting for Approval List")
            : props.t("Graduated Startups")}
        </title>
      </Helmet>
      {props.module === TabModule.PROJECT_APPROVAL ?
      <Container fluid>
        {/* BreadCrumb area starts */}
        <div className="mainPageHeader d-flex justify-content-between">
          <BreadCrumb
            title={
              props.module === TabModule.PROJECT_APPROVAL
                ? props.t("Startups Waiting for Approval")
                : props.t("Graduated Startups")
            }
          />
        </div>
        <div className="milestoneSubmission accordionTable my-4">
          <CommentModal
            handleRejectModal={handleClose}
            open={open}
            handleApproval={handleTriggerAdd}
            module={Modules.PROJECT}
          />
          <Card>
            <CardBody>
              <div style={{ height: 400, width: "100%" }}>
                <Box
                  sx={{
                    height: 400,
                    width: "100%",
                    "& .super-app-theme--header": {
                      backgroundColor: "rgba(0, 173, 255, 0.55)",
                    },
                  }}
                >
                  {rows.length > 0 && (
                    <DataGrid
                      rows={rows}
                      columns={columns}
                      initialState={{
                        pagination: {
                          paginationModel: { pageSize: rowsPerPage },
                        },
                      }}
                      pageSizeOptions={PerPage}
                      style={{ border: "unset" }}
                      paginationMode="server"
                      rowCount={totalRows}
                      key={triggerState}
                      onPaginationModelChange={paginationModelMethod}
                      loading={isLoading}
                      disableRowSelectionOnClick
                      getRowId={getRowId}
                      localeText={{
                        MuiTablePagination: {
                          labelRowsPerPage: t("Startups per page:"),
                        },
                      }}
                    />
                  )}
                  {rows.length === 0 && isLoading && <Loader />}
                  {rows.length === 0 && !isLoading && (
                    <NodataFound
                      text={
                        props.module === TabModule.PROJECT_APPROVAL
                          ? props.t("No Startups Waiting for Approval to show")
                          : props.t("No Startups Waiting for Completion to show")
                      }
                      icon={Ticket}
                    />
                  )}
                </Box>
              </div>
            </CardBody>
          </Card>
        </div>
      </Container> :
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center ongoingProjectsPg">
          <div className="mainPageHeader d-flex justify-content-between">
            <BreadCrumb title={props.t("Graduated Startups")} />
          </div>
          <div className="d-flex justify-content-end ongoingSearchField">
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    page: 1,
                    perPage: rowsPerPage2,
                    filterFields: ["status"],
                    filterInputs: [ProjectStatuses.COMPLETED]
                  }}
                />
                {/* <SearchOutlinedIcon /> */}
              </div>
            </div>
        </div>
        <div className="accordionTable my-4" style={{ width: "100%" }}>
            {projectList.length > 0 && (
              <DataGrid
                key={refreshKey}
                rows={projectList}
                columns={columnData}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage2 },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethodForComplete}
                rowCount={rowCount}
                pageSizeOptions={PerPage}
                getRowId={getRowIdForComplete}
                loading={isLoadingForComplete}
                // onRowSelectionModelChange={(e) => setIsSendMsg({ data: e, status: false })}
                // checkboxSelection={loggedInUser?.role?.name === Role.EPMO_OFFICER}
                localeText={{
                  MuiTablePagination: {
                    labelRowsPerPage: props.t("Startups per page:"),
                  },
                }}
              />
            )}
            {projectList.length === 0 && isLoadingForComplete && <Loader />}
            {projectList.length === 0 && !isLoadingForComplete && (
              <NodataFound text={props.t("No startup to show")} icon={userImage} />
            )}
        </div>
      </Container>
      }
    </div>
  );
}

export default withTranslation()(ProjectApproalSubmission);
